import QRCode from 'qrcode';

/**
 * Generate QR code as data URL (base64)
 * @param {string} data - Data to encode in QR code (e.g., pod number)
 * @returns {Promise<string>} - Base64 data URL of the QR code
 */
export const generateQRCodeDataURL = async (data) => {
  try {
    const qrCodeDataURL = await QRCode.toDataURL(data, {
      width: 300,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      },
      errorCorrectionLevel: 'H'
    });
    return qrCodeDataURL;
  } catch (error) {
    console.error('Error generating QR code:', error);
    throw error;
  }
};

/**
 * Convert data URL to Blob
 * @param {string} dataURL - Base64 data URL
 * @returns {Blob} - Blob object
 */
export const dataURLToBlob = (dataURL) => {
  const arr = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

/**
 * Generate QR code as Blob
 * @param {string} data - Data to encode in QR code
 * @returns {Promise<Blob>} - Blob of the QR code image
 */
export const generateQRCodeBlob = async (data) => {
  const dataURL = await generateQRCodeDataURL(data);
  return dataURLToBlob(dataURL);
};
